import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import Brand from 'models/brand';
import { ParkingPass } from 'models/parking-passes';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  parkingPass: PropTypes.instanceOf(ParkingPass).isRequired,
};

const getStyles = (brand, cancellableNow) => cx(
  'col-xs-12 col-md-8 margin-bottom-15 text-align-sm-left',
  {
    'clickable text-color-blue': cancellableNow,
    'text-color-dark-slate': !cancellableNow,
    'col-gutter-right-md-30': !!brand.helpWebsiteURL || !!brand.helpPhone,
  },
);

const ParkingPassCancelButton = ({ brand, parkingPass }) => {
  const {
    cancellableNow,
    message,
  } = parkingPass.cancellableStatus;

  const styles = getStyles(brand, cancellableNow);

  if (!cancellableNow) {
    return (
      <div className={styles}>
        { message }
      </div>
    );
  }

  return (
    <Link
      to={{
        pathname: `/ticket/cancel/${parkingPass.id}/`,
        search: `?u=${parkingPass.authorizationCode}`,
      }}
      className={styles}
    >
      { message }
    </Link>
  );
};

ParkingPassCancelButton.propTypes = propTypes;
export default ParkingPassCancelButton;
